import {get, post, postJson} from './axios'

// 短信发送api

const RESOURCE_BASE_PATH = '/sms'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/sms'

// 短信预提交
export const preCommit = p => postJson(`${RESOURCE_BASE_PATH}/pre/commit`, p);

// 平台的短信发送
export const platformSend = p => postJson(`${RESOURCE_BASE_PATH}/send`, p);

// 精准营销提交发送
export const precisionMarketing = p => postJson(`${RESOURCE_BASE_PATH}/precision-marketing`, p);

// 查询短信批次记录
export const sendBatchPage = p => get(`${RESOURCE_BASE_PATH}/send-batch/page`, p);

// 取消发送
export const sendCancel = p => postJson(`${RESOURCE_BASE_PATH}/cancel`, p);

// 获取导入发送二次发送内容
export const againSend = p => get(`${RESOURCE_BASE_PATH}/again/send/import/${p}`);

// 获取当前系统配置的发送时段
export const getSendTime = p => get(`${RESOURCE_BASE_PATH}/official/send-time`, p);

// 官方打包发送短信效果分析详情
export const getOfficialEffect = p => get(`${RESOURCE_BASE_PATH}/official/effect`, p);